import { coerceNumberProperty } from "@angular/cdk/coercion";
import { Catalog } from "@models/catalog/Catalog";

export const toItem = (item: Catalog) => ({
  ...item,
  id: coerceNumberProperty(item.id, 0),
});

export const toItems = (items: Catalog[]) => {
  return items.map(x => toItem(x));
}
